module.exports = __webpack_public_path__ + "img/rect.a97b5d91.svg";